export default [  
  {
    path: '/user-logs',
    name: 'user-logs',
    component: () => import('@/views/modules/user-logs/list'),
    meta: {
      requiresAuth: true,
      layout: 'app',
      title:'User Logs',
      breadcrumb: [
        { text: 'Home',  to: { name: "home" } },
        { text: 'Users Logs' }
      ]
    },   
    
  },  
  {
    path: '/user-logs/:id/show',
    props: true,
    name: 'user-logs-show',
    component: () => import('@/views/modules/user-logs/show'),
    meta: {
      requiresAuth: true,
      layout: 'app',
      title:'Logs',
      breadcrumb: [
        { text: 'Home',  to: { name: "home" } },
        { text: 'Users Logs',  to: { name: "user-logs" } },
        { text: 'Logs' }
      ]
    },
   
  },
  {
    path: '/user-logs/:id/show/:logId',
    props: true,
    name: 'user-logs-show-details',
    component: () => import('@/views/modules/user-logs/details'),
    meta: {
      requiresAuth: true,
      layout: 'app',
      title:'Log Details',
      breadcrumb: [
        { text: 'Home',  to: { name: "home" } },
        { text: 'Users Logs',  to: { name: "user-logs" } },
        { text: 'Logs',  to: { name: 'user-logs-show'}, param: 'id' },
        { text: 'Details' }
      ]
    }
  }
  
 
]